import React from 'react';
import GumtreeLogo from '@gumtree/ui-library/src/assets/gumtree-logo.png';
import BarkLogoInfo from '../bark-logo-info';
import { DialogHeaderContainer, Img } from './index.style';

const DialogHeader: React.FC = () => {
    return (
        <DialogHeaderContainer>
            <Img src={GumtreeLogo} alt="Gumtree Logo" />
            <span>in partnership with</span>
            <BarkLogoInfo />
        </DialogHeaderContainer>
    );
}

export default DialogHeader;
